// extracted by mini-css-extract-plugin
export default {"dropzoneWrapper":"FileDropzone_dropzoneWrapper__egfsW","label":"FileDropzone_label__jOuWa","closeButton":"FileDropzone_closeButton__Za8Th"};